export const translations = {
  tr: {
    nav: {
      about: 'Hakkımızda',
      services: 'Hizmetler',
      approach: 'Yaklaşım',
      contact: 'İletişim',
      getQuote: 'Teklif Alın'
    },
    hero: {
      title: 'Güçlü Organizasyonlar,',
      titleHighlight: 'Güven Veren Markalar',
      subtitle: 'İnsan Kaynakları, Kurumsal Yazılım Çözümleri ve Dijital Pazarlama alanlarını bütüncül bir yaklaşımla ele alarak markaların sürdürülebilir dönüşümünü ve büyümesini destekleyen stratejik danışmanlık merkezi.',
      discoverServices: 'Hizmetlerimizi Keşfedin',
      getQuote: 'Teklif Alın'
    },
    about: {
      badge: 'Hakkımızda',
      title: 'Stratejik',
      titleHighlight: 'İş Ortağınız',
      description1: 'Hippo Partners, markaların insan kaynakları, kurumsal yazılım çözümleri ve dijital pazarlama süreçlerini stratejik bir bütün olarak ele almak üzere kurulmuş bir danışmanlık ve dönüşüm merkezidir.',
      description2: 'Standart çözümler yerine',
      description2Highlight: 'ihtiyaca özel, yüksek etki yaratan',
      description2End: 'projeler üretiriz.',
      point1: 'Manuel yükü azaltan çözümler',
      point2: 'Uçtan uca dijital dönüşüm',
      point3: 'Sürdürülebilir büyüme odaklılık'
    },
    aiFeature: {
      free: 'ÜCRETSİZ',
      bonus: 'Bonus Hizmet',
      title: '7/24 Yapay Zeka Tabanlı İK Danışmanlığı',
      description: 'Tüm müşterilerimize 7/24 erişilebilir, yapay zeka destekli İK danışmanlık hizmeti paket içerisinde',
      descriptionHighlight: 'tamamen ücretsiz',
      descriptionEnd: 'sunulmaktadır.',
      access247: '7/24 Erişim',
      aiPowered: 'AI Destekli',
      free2: 'Ücretsiz'
    },
    impact: {
      badge: 'Rakamlarla Etki',
      title: 'Ölçülebilir',
      titleHighlight: 'Sonuçlar',
      stat1: {
        value: '%30',
        label: 'Daha Hızlı İşe Alım',
        description: 'AI destekli süreçlerle işe alım sürelerinde azalma'
      },
      stat2: {
        value: '%40',
        label: 'Manuel Yük Azalması',
        description: 'Dijital dönüşüm ile operasyonel verimlilik artışı'
      },
      stat3: {
        value: '%25',
        label: 'Maliyet Verimliliği',
        description: 'Proje bazlı danışmanlık ile maliyet optimizasyonu'
      },
      stat4: {
        value: '7/24',
        label: 'AI Desteği',
        description: 'Kesintisiz yapay zeka destekli İK danışmanlığı'
      }
    },
    services: {
      badge: 'Hizmet Alanlarımız',
      title: 'Stratejik İK Çözümleri',
      titleHighlight: 'Ölçülebilir Sonuçlar',
      detailInfo: 'Detaylı Bilgi',
      service1: {
        title: 'AI Tabanlı İşe Alım Danışmanlığı',
        subtitle: 'Doğru Yeteneği, Doğru Zamanda',
        description: 'Yapay zeka destekli analiz ile aday havuzunu hızla tarar, doğru profilleri veriye dayalı belirler ve kritik pozisyonlar için özel aday arama çalışmaları yürütürüz.',
        features: {
          0: 'AI destekli aday eşleştirme',
          1: 'Kritik roller için özel aday arama',
          2: 'Süreç bazlı KPI takibi',
          3: 'İşe alım sürecinde %30\'a kadar hızlanma'
        }
      },
      service2: {
        title: 'İK Sistem Kurulumu & Dış Kaynak Kullanımı',
        subtitle: 'Dijitalleştirin, Yükü Azaltın',
        description: 'Sistem tasarımından dijital entegrasyona, dış kaynak kullanımından süreç yönetimine kadar uçtan uca çözümler sunarız.',
        features: {
          0: 'İK altyapı ve sistem kurulumu',
          1: 'Dijital dönüşüm projeleri',
          2: 'Bordro & operasyon outsource',
          3: 'Manuel iş yükünde %40\'a varan azalma'
        }
      },
      service3: {
        title: 'Proje Bazlı İK Danışmanlığı',
        subtitle: 'Stratejik Dönüşüm',
        description: 'İhtiyaca özel, proje bazlı ve sonuç odaklı çözümler geliştiririz. Standart paketler değil, stratejik dönüşüm.',
        features: {
          0: 'Organizasyonel yapılandırma',
          1: 'Performans sistemi kurulumu',
          2: 'KPI tasarımı',
          3: 'Maliyet verimliliğinde %25\'e kadar iyileşme'
        }
      },
      service4: {
        title: 'Dijital İK Eğitimi',
        subtitle: 'Geleceğin İK Yetkinlikleri',
        description: 'İK ekiplerinizi dijital çağın gereksinimlerine hazırlayan kapsamlı eğitim programları sunuyoruz.',
        features: {
          0: 'AI ile İşe Alımda Dönüşüm',
          1: 'Dijital İşe Alım Süreç Tasarımı',
          2: 'Yetkinlik Bazlı İşe Alım Teknikleri',
          3: 'Dijital Onboarding: Süreç, Araç ve Ölçümleme'
        }
      },
      service5: {
        title: 'Kurumsal Yazılım Çözümleri',
        subtitle: 'Dijital Altyapı Ortaklığı',
        description: 'İş ortaklarımız aracılığıyla kurumsal yazılım ihtiyaçlarınıza yönelik kapsamlı çözümler sunuyoruz.',
        features: {
          0: 'Kurumsal Kaynak Planlama (ERP)',
          1: 'İnsan Kaynakları Yönetim Sistemleri',
          2: 'Müşteri İlişkileri Yönetimi (CRM)',
          3: 'Bordro ve Özlük Yönetimi'
        }
      }
    },
    approach: {
      badge: 'Nasıl Çalışıyoruz?',
      title: '3 Adımda',
      titleHighlight: 'Dönüşüm',
      step1: {
        title: 'Analiz',
        description: 'Mevcut İK problemlerini ve karmaşayı netleştiriyoruz.'
      },
      step2: {
        title: 'Strateji',
        description: 'Kurumunuza özel, sürdürülebilir bir yol haritası tasarlıyoruz.'
      },
      step3: {
        title: 'Uygulama',
        description: 'Sürecin her aşamasında stratejik iş ortağı olarak yanınızdayız.'
      }
    },
    contact: {
      badge: 'İletişim',
      title: 'Bize Ulaşın',
      subtitle: 'Dönüşüm yolculuğunuzu birlikte başlatalım.',
      emailTitle: 'E-posta',
      emailDescription: 'Bize e-posta gönderin, en kısa sürede geri dönelim.',
      linkedinTitle: 'LinkedIn',
      partnerTitle: 'Stratejik İş Ortağınız',
      partnerDescription: 'Hippo Partners ile güçlü organizasyonlar ve güven veren markalar oluşturun.'
    },
    footer: {
      description: 'Güçlü organizasyonlar, güven veren markalar ve sürdürülebilir büyüme için stratejik İK danışmanlık ve dijital dönüşüm partneri.',
      quickLinks: 'Hızlı Erişim',
      serviceAreas: 'Hizmet Alanları',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları',
      copyright: '© 2025 Hippo Partners. Tüm Hakları Saklıdır.'
    },
    serviceDetail: {
      backToHome: 'Ana Sayfaya Dön',
      benefits: 'Sağladığımız Değerler',
      serviceDetails: 'Hizmet Detayları',
      howWeWork: 'Nasıl Çalışıyoruz?',
      ctaTitle: 'Birlikte Başlayalım',
      ctaDescription: 'hizmetimiz hakkında detaylı bilgi almak ve teklif için bize ulaşın.',
      getQuote: 'Teklif Alın',
      otherServices: 'Diğer Hizmetler',
      notFound: 'Hizmet Bulunamadı'
    },
    servicePages: {
      service1: {
        slug: 'ai-tabanli-secme-yerlestirme',
        title: 'AI Tabanlı İşe Alım Danışmanlığı',
        subtitle: 'Doğru Yeteneği, Doğru Zamanda',
        description: 'Yapay zeka destekli analiz ile aday havuzunu hızla tarar, doğru profilleri veriye dayalı belirler ve kritik pozisyonlar için özel aday arama çalışmaları yürütürüz.',
        gradient: 'from-orange-400 to-pink-500',
        heroImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902',
        benefits: [
          { title: 'Hızlı Aday Eşleştirme', description: 'AI destekli sistem ile en uygun adayları saniyeler içinde belirleyin.' },
          { title: 'Doğru Profil Tespiti', description: 'Veriye dayalı analiz ile pozisyona en uygun adayları bulun.' },
          { title: 'Kritik Pozisyon Desteği', description: 'Üst düzey pozisyonlar için hedefli aday arama hizmeti.' }
        ],
        services: [
          'AI destekli aday tarama ve eşleştirme',
          'Yetkinlik bazlı mülakat tasarımı',
          'Kritik pozisyonlar için özel aday arama hizmeti',
          'Aday değerlendirme ve assessment',
          'İşe alım süreci KPI takibi',
          'Employer branding stratejisi'
        ],
        process: [
          { step: '01', title: 'İhtiyaç Analizi', description: 'Pozisyon gereksinimleri ve ideal aday profilini belirliyoruz.' },
          { step: '02', title: 'AI Tarama', description: 'Yapay zeka ile aday havuzunu tarayıp en uygun profilleri belirliyoruz.' },
          { step: '03', title: 'Değerlendirme & Yerleştirme', description: 'Detaylı değerlendirme sonrası en uygun adayı yerleştiriyoruz.' }
        ]
      },
      service2: {
        slug: 'ik-sistem-kurulum',
        title: 'İK Sistem Kurulumu & Dış Kaynak Kullanımı',
        subtitle: 'Dijitalleştirin, Yükü Azaltın',
        description: 'Sistem tasarımından dijital entegrasyona, dış kaynak kullanımından süreç yönetimine kadar uçtan uca çözümler sunarız.',
        gradient: 'from-pink-400 to-purple-500',
        heroImage: 'https://images.unsplash.com/photo-1551434678-e076c223a692',
        benefits: [
          { title: 'Operasyonel Verimlilik', description: 'Manuel süreçleri otomatikleştirin, zamandan tasarruf edin.' },
          { title: 'Maliyet Optimizasyonu', description: 'Dijitalleşme ile İK operasyonlarınızın maliyetini düşürün.' },
          { title: 'Esnek Kaynak Yönetimi', description: 'İhtiyaçlarınıza göre ölçeklenebilir dış kaynak çözümleri.' }
        ],
        services: [
          'İK altyapı ve sistem kurulumu',
          'ATS ve performans sistemi entegrasyonu',
          'Bordro ve operasyon outsource',
          'Dijital dönüşüm projeleri',
          'Part-time İK yöneticiliği',
          'Süreç optimizasyonu'
        ],
        process: [
          { step: '01', title: 'Mevcut Durum Analizi', description: 'İK süreçlerinizi ve dijitalleşme olgunluk seviyenizi değerlendiriyoruz.' },
          { step: '02', title: 'Sistem Tasarımı', description: 'İhtiyaçlarınıza uygun teknoloji ve sistem altyapısını tasarlıyoruz.' },
          { step: '03', title: 'Uygulama & Eğitim', description: 'Sistemleri devreye alıyor, ekiplerinizi eğitiyoruz.' }
        ]
      },
      service3: {
        slug: 'proje-bazli-danismanlik',
        title: 'Proje Bazlı İK Danışmanlığı',
        subtitle: 'Stratejik Dönüşüm',
        description: 'İhtiyaca özel, proje bazlı ve sonuç odaklı çözümler geliştiririz. Standart paketler değil, stratejik dönüşüm.',
        gradient: 'from-purple-400 to-blue-500',
        heroImage: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40',
        benefits: [
          { title: 'İhtiyaca Özel Çözümler', description: 'Standart değil, sizin için tasarlanmış projeler.' },
          { title: 'Hızlı Sonuç', description: 'Proje bazlı yaklaşım ile kısa sürede somut çıktılar.' },
          { title: 'Ölçülebilir Etki', description: 'Net KPI\'lar ile proje başarısını takip edin.' }
        ],
        services: [
          'Organizasyonel yapılandırma',
          'Performans sistemi kurulumu',
          'KPI tasarımı ve takibi',
          'İK strateji geliştirme',
          'Yetkinlik modeli oluşturma',
          'Dönüşüm projeleri yönetimi'
        ],
        process: [
          { step: '01', title: 'Proje Kapsamı', description: 'İhtiyaçlarınızı analiz edip proje kapsamını belirliyoruz.' },
          { step: '02', title: 'Strateji & Tasarım', description: 'Size özel strateji ve çözüm tasarımı yapıyoruz.' },
          { step: '03', title: 'Uygulama & Ölçüm', description: 'Projeyi uygulayıp sonuçları ölçümlüyoruz.' }
        ]
      },
      service4: {
        slug: 'dijital-ik-egitimi',
        title: 'Dijital İK Eğitimi',
        subtitle: 'Geleceğin İK Yetkinlikleri',
        description: 'İK ekiplerinizi dijital çağın gereksinimlerine hazırlayan kapsamlı eğitim programları sunuyoruz. Yapay zeka destekli işe alımdan dijital onboarding süreçlerine kadar tüm modern İK uygulamalarını öğretin.',
        gradient: 'from-green-400 to-teal-500',
        heroImage: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655',
        benefits: [
          { title: 'Güncel İK Bilgisi', description: 'Sektördeki en son trendler ve en iyi uygulamalar hakkında bilgi edinin.' },
          { title: 'Uygulamalı Eğitim', description: 'Teorik bilginin ötesinde, gerçek senaryolarla pratik yapın.' }
        ],
        services: [
          'AI ile İşe Alımda Dönüşüm',
          'Dijital İşe Alım Süreç Tasarımı',
          'Yetkinlik Bazlı İşe Alım Teknikleri',
          'Dijital Onboarding: Süreç, Araç ve Ölçümleme'
        ],
        process: [
          { step: '01', title: 'İhtiyaç Analizi', description: 'Ekibinizin mevcut yetkinlik seviyesini ve eğitim ihtiyaçlarını belirliyoruz.' },
          { step: '02', title: 'Program Tasarımı', description: 'Kurumunuza özel, modüler eğitim programı hazırlıyoruz.' },
          { step: '03', title: 'Uygulama & Takip', description: 'Eğitimleri gerçekleştirip, öğrenme çıktılarını ölçümlüyoruz.' }
        ]
      },
      service5: {
        slug: 'kurumsal-yazilim-cozumleri',
        title: 'Kurumsal Yazılım Çözümleri',
        subtitle: 'Dijital Altyapı Ortaklığı',
        description: 'İş ortaklarımız aracılığıyla kurumsal yazılım ihtiyaçlarınıza yönelik kapsamlı çözümler sunuyoruz. ERP, İK yazılımları, CRM ve e-dönüşüm çözümleriyle işletmenizin dijital altyapısını güçlendirin.',
        gradient: 'from-blue-400 to-indigo-500',
        heroImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
        benefits: [
          { title: 'Entegre Çözümler', description: 'Tüm iş süreçlerinizi tek bir platformda yönetin.' },
          { title: 'Bulut Teknolojisi', description: 'İşinizi her yerden güvenle yönetin.' }
        ],
        services: [
          'Kurumsal Kaynak Planlama (ERP) Sistemleri',
          'İnsan Kaynakları Yönetim Sistemleri (HRMS)',
          'Müşteri İlişkileri Yönetimi (CRM)',
          'Bordro ve Özlük Yönetimi',
          'e-Fatura ve e-Defter Çözümleri',
          'e-İrsaliye ve e-Arşiv Sistemleri',
          'Ön Muhasebe Yazılımları',
          'Elektronik İmza Çözümleri'
        ],
        process: [
          { step: '01', title: 'İhtiyaç Analizi', description: 'İşletmenizin yazılım ihtiyaçlarını ve mevcut altyapınızı değerlendiriyoruz.' },
          { step: '02', title: 'Çözüm Eşleştirme', description: 'İş ortaklarımız arasından size en uygun çözümü belirliyoruz.' },
          { step: '03', title: 'Kurulum & Destek', description: 'Yazılım kurulumu ve entegrasyonunda destek sağlıyoruz.' }
        ]
      }
    }
  },
  en: {
    nav: {
      about: 'About Us',
      services: 'Services',
      approach: 'Approach',
      contact: 'Contact',
      getQuote: 'Get Quote'
    },
    hero: {
      title: 'Strong Organizations,',
      titleHighlight: 'Trusted Brands',
      subtitle: 'A strategic consulting center that takes a holistic approach to Human Resources, Enterprise Software Solutions and Digital Marketing, supporting sustainable transformation and growth of brands.',
      discoverServices: 'Discover Our Services',
      getQuote: 'Get Quote'
    },
    about: {
      badge: 'About Us',
      title: 'Your Strategic',
      titleHighlight: 'Business Partner',
      description1: 'Hippo Partners is a consulting and transformation center established to strategically manage brands\' human resources, enterprise software solutions and digital marketing processes as an integrated whole.',
      description2: 'Instead of standard solutions, we produce',
      description2Highlight: 'needs-specific, high-impact',
      description2End: 'projects.',
      point1: 'Solutions that reduce manual workload',
      point2: 'End-to-end digital transformation',
      point3: 'Sustainable growth focus'
    },
    aiFeature: {
      free: 'FREE',
      bonus: 'Bonus Service',
      title: '24/7 AI-Powered HR Consulting',
      description: 'All our customers receive 24/7 accessible, AI-powered HR consulting service',
      descriptionHighlight: 'completely free',
      descriptionEnd: 'as part of the package.',
      access247: '24/7 Access',
      aiPowered: 'AI Powered',
      free2: 'Free'
    },
    impact: {
      badge: 'Impact by Numbers',
      title: 'Measurable',
      titleHighlight: 'Results',
      stat1: {
        value: '30%',
        label: 'Faster Recruitment',
        description: 'Reduced hiring time with AI-powered processes'
      },
      stat2: {
        value: '40%',
        label: 'Less Manual Work',
        description: 'Increased operational efficiency through digital transformation'
      },
      stat3: {
        value: '25%',
        label: 'Cost Efficiency',
        description: 'Cost optimization with project-based consulting'
      },
      stat4: {
        value: '24/7',
        label: 'AI Support',
        description: 'Non-stop AI-powered HR consulting'
      }
    },
    services: {
      badge: 'Our Service Areas',
      title: 'Strategic HR Solutions',
      titleHighlight: 'Measurable Results',
      detailInfo: 'Learn More',
      service1: {
        title: 'AI-Based Recruitment Consulting',
        subtitle: 'Right Talent, Right Time',
        description: 'With AI-powered analysis, we quickly scan the candidate pool, identify the right profiles based on data, and conduct targeted executive search efforts for critical positions.',
        features: {
          0: 'AI-powered candidate matching',
          1: 'Targeted executive search for critical roles',
          2: 'Process-based KPI tracking',
          3: 'Up to 30% faster recruitment process'
        }
      },
      service2: {
        title: 'HR System Setup & Outsourcing',
        subtitle: 'Digitalize, Reduce Workload',
        description: 'From system design to digital integration, from outsourcing to process management, we offer end-to-end solutions.',
        features: {
          0: 'HR infrastructure and system setup',
          1: 'Digital transformation projects',
          2: 'Payroll & operations outsource',
          3: 'Up to 40% reduction in manual workload'
        }
      },
      service3: {
        title: 'Project-Based HR Consulting',
        subtitle: 'Strategic Transformation',
        description: 'We develop needs-specific, project-based, and results-oriented solutions. Not standard packages, but strategic transformation.',
        features: {
          0: 'Organizational structuring',
          1: 'Performance system setup',
          2: 'KPI design',
          3: 'Up to 25% improvement in cost efficiency'
        }
      },
      service4: {
        title: 'Digital HR Training',
        subtitle: 'Future HR Competencies',
        description: 'We offer comprehensive training programs that prepare your HR teams for the requirements of the digital age.',
        features: {
          0: 'AI Transformation in Recruitment',
          1: 'Digital Recruitment Process Design',
          2: 'Competency-Based Recruitment Techniques',
          3: 'Digital Onboarding: Process, Tools & Measurement'
        }
      },
      service5: {
        title: 'Enterprise Software Solutions',
        subtitle: 'Digital Infrastructure Partnership',
        description: 'Through our business partners, we provide comprehensive solutions for your enterprise software needs.',
        features: {
          0: 'Enterprise Resource Planning (ERP)',
          1: 'Human Resources Management Systems',
          2: 'Customer Relationship Management (CRM)',
          3: 'Payroll and Personnel Management'
        }
      }
    },
    approach: {
      badge: 'How We Work?',
      title: 'Transformation in',
      titleHighlight: '3 Steps',
      step1: {
        title: 'Analysis',
        description: 'We clarify existing HR problems and complexity.'
      },
      step2: {
        title: 'Strategy',
        description: 'We design a sustainable roadmap specific to your organization.'
      },
      step3: {
        title: 'Implementation',
        description: 'We are with you as a strategic business partner at every stage of the process.'
      }
    },
    contact: {
      badge: 'Contact',
      title: 'Get In Touch',
      subtitle: 'Let\'s start your transformation journey together.',
      emailTitle: 'Email',
      emailDescription: 'Send us an email, we\'ll get back to you as soon as possible.',
      linkedinTitle: 'LinkedIn',
      partnerTitle: 'Your Strategic Partner',
      partnerDescription: 'Create strong organizations and trusted brands with Hippo Partners.'
    },
    footer: {
      description: 'Strategic HR consulting and digital transformation partner for strong organizations, trusted brands, and sustainable growth.',
      quickLinks: 'Quick Links',
      serviceAreas: 'Service Areas',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      copyright: '© 2025 Hippo Partners. All Rights Reserved.'
    },
    serviceDetail: {
      backToHome: 'Back to Home',
      benefits: 'Benefits We Provide',
      serviceDetails: 'Service Details',
      howWeWork: 'How We Work?',
      ctaTitle: 'Let\'s Get Started',
      ctaDescription: 'service for detailed information and quote, please contact us.',
      getQuote: 'Get Quote',
      otherServices: 'Other Services',
      notFound: 'Service Not Found'
    },
    servicePages: {
      service1: {
        slug: 'ai-tabanli-secme-yerlestirme',
        title: 'AI-Based Recruitment Consulting',
        subtitle: 'Right Talent, Right Time',
        description: 'With AI-powered analysis, we quickly scan the candidate pool, identify the right profiles based on data, and conduct targeted executive search efforts for critical positions.',
        gradient: 'from-orange-400 to-pink-500',
        heroImage: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902',
        benefits: [
          { title: 'Fast Candidate Matching', description: 'Identify the best candidates in seconds with our AI-powered system.' },
          { title: 'Accurate Profile Detection', description: 'Find the most suitable candidates through data-driven analysis.' },
          { title: 'Critical Position Support', description: 'Targeted executive search service for senior positions.' }
        ],
        services: [
          'AI-powered candidate screening and matching',
          'Competency-based interview design',
          'Executive search service for critical positions',
          'Candidate evaluation and assessment',
          'Recruitment process KPI tracking',
          'Employer branding strategy'
        ],
        process: [
          { step: '01', title: 'Needs Analysis', description: 'We determine position requirements and ideal candidate profile.' },
          { step: '02', title: 'AI Screening', description: 'We scan the candidate pool with AI and identify the best profiles.' },
          { step: '03', title: 'Evaluation & Placement', description: 'We place the most suitable candidate after detailed evaluation.' }
        ]
      },
      service2: {
        slug: 'ik-sistem-kurulum',
        title: 'HR System Setup & Outsourcing',
        subtitle: 'Digitalize, Reduce Workload',
        description: 'From system design to digital integration, from outsourcing to process management, we offer end-to-end solutions.',
        gradient: 'from-pink-400 to-purple-500',
        heroImage: 'https://images.unsplash.com/photo-1551434678-e076c223a692',
        benefits: [
          { title: 'Operational Efficiency', description: 'Automate manual processes and save time.' },
          { title: 'Cost Optimization', description: 'Reduce HR operations costs through digitalization.' },
          { title: 'Flexible Resource Management', description: 'Scalable outsourcing solutions according to your needs.' }
        ],
        services: [
          'HR infrastructure and system setup',
          'ATS and performance system integration',
          'Payroll and operations outsource',
          'Digital transformation projects',
          'Part-time HR management',
          'Process optimization'
        ],
        process: [
          { step: '01', title: 'Current State Analysis', description: 'We evaluate your HR processes and digitalization maturity level.' },
          { step: '02', title: 'System Design', description: 'We design the technology and system infrastructure suitable for your needs.' },
          { step: '03', title: 'Implementation & Training', description: 'We deploy systems and train your teams.' }
        ]
      },
      service3: {
        slug: 'proje-bazli-danismanlik',
        title: 'Project-Based HR Consulting',
        subtitle: 'Strategic Transformation',
        description: 'We develop needs-specific, project-based, and results-oriented solutions. Not standard packages, but strategic transformation.',
        gradient: 'from-purple-400 to-blue-500',
        heroImage: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40',
        benefits: [
          { title: 'Customized Solutions', description: 'Projects designed specifically for you, not standard packages.' },
          { title: 'Quick Results', description: 'Tangible outputs in a short time with project-based approach.' },
          { title: 'Measurable Impact', description: 'Track project success with clear KPIs.' }
        ],
        services: [
          'Organizational structuring',
          'Performance system setup',
          'KPI design and tracking',
          'HR strategy development',
          'Competency model creation',
          'Transformation project management'
        ],
        process: [
          { step: '01', title: 'Project Scope', description: 'We analyze your needs and determine the project scope.' },
          { step: '02', title: 'Strategy & Design', description: 'We create a custom strategy and solution design for you.' },
          { step: '03', title: 'Implementation & Measurement', description: 'We implement the project and measure the results.' }
        ]
      },
      service4: {
        slug: 'dijital-ik-egitimi',
        title: 'Digital HR Training',
        subtitle: 'Future HR Competencies',
        description: 'We offer comprehensive training programs that prepare your HR teams for the requirements of the digital age. From AI-powered recruitment to digital onboarding processes, learn all modern HR practices.',
        gradient: 'from-green-400 to-teal-500',
        heroImage: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655',
        benefits: [
          { title: 'Up-to-Date HR Knowledge', description: 'Learn about the latest trends and best practices in the industry.' },
          { title: 'Hands-On Training', description: 'Practice with real scenarios beyond theoretical knowledge.' }
        ],
        services: [
          'AI Transformation in Recruitment',
          'Digital Recruitment Process Design',
          'Competency-Based Recruitment Techniques',
          'Digital Onboarding: Process, Tools & Measurement'
        ],
        process: [
          { step: '01', title: 'Needs Analysis', description: 'We determine your team\'s current competency level and training needs.' },
          { step: '02', title: 'Program Design', description: 'We prepare a modular training program specific to your organization.' },
          { step: '03', title: 'Implementation & Follow-up', description: 'We conduct training and measure learning outcomes.' }
        ]
      },
      service5: {
        slug: 'kurumsal-yazilim-cozumleri',
        title: 'Enterprise Software Solutions',
        subtitle: 'Digital Infrastructure Partnership',
        description: 'Through our business partners, we provide comprehensive solutions for your enterprise software needs. Strengthen your business digital infrastructure with ERP, HR software, CRM and e-transformation solutions.',
        gradient: 'from-blue-400 to-indigo-500',
        heroImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f',
        benefits: [
          { title: 'Integrated Solutions', description: 'Manage all your business processes on a single platform.' },
          { title: 'Cloud Technology', description: 'Manage your business securely from anywhere.' }
        ],
        services: [
          'Enterprise Resource Planning (ERP) Systems',
          'Human Resources Management Systems (HRMS)',
          'Customer Relationship Management (CRM)',
          'Payroll and Personnel Management',
          'e-Invoice and e-Ledger Solutions',
          'e-Waybill and e-Archive Systems',
          'Pre-Accounting Software',
          'Electronic Signature Solutions'
        ],
        process: [
          { step: '01', title: 'Needs Analysis', description: 'We evaluate your business software needs and existing infrastructure.' },
          { step: '02', title: 'Solution Matching', description: 'We identify the most suitable solution among our business partners.' },
          { step: '03', title: 'Setup & Support', description: 'We provide support in software installation and integration.' }
        ]
      }
    }
  }
};
